import autocompleteHtml from './autocomplete.html';
import './autocomplete.scss';

class AutocompleteDirective {
    constructor() {

        this.restrict = 'AE';
        this.scope = {
            model: '=',
            options: '=',
            ngDisabled: '=',
            placeholder: '@',
            customClass: '@',
            submit: '&',
            select: '&',
            showModal: '=',
            loading: '<',
            omitNextAutocomplete: '='
        };
        this.replace = true;
        this.transclude = true;
        this.controllerAs = '$ctrl';
        this.bindToController = true;
        this.template = autocompleteHtml;
        this.controller = AutocompleteDirectiveController;
    }

    static directiveFactory() {
        'ngInject';
        return new AutocompleteDirective();
    }
}

class AutocompleteDirectiveController {
    constructor($scope, $sce, $filter, $window) {
        'ngInject';

        this.$scope = $scope;
        this.$sce = $sce;
        this.$filter = $filter;
        this.$window = $window;

        this.selected = {key: '', index: -1};
        this.omitNextAutocomplete = false;
        this.showOptions = false;
        this.showModal = false;
        this.search = '';
        this.searchUrl = '';

        this.$scope.$watch(
            () => this.options,
            (newVal) => {
                this.autocomplete(this.model);
            },
            true
        );
    }

    get isMobile() {
        return window.innerWidth < 767;
    }

    get selectKeys() {

        let order = ['products_categories', 'categories', 'products'];

        if (this.isMobile) {
            order = ['products', 'products_categories', 'categories'];
        }

        return order.filter(key => this.filteredOptions[key] && this.filteredOptions[key].length > 0);
    }

    hideModal() {
        this.showModal = false;
        this.showOptions = false;
    }

    clickOption(rawMatch) {
        this.showOptions = false;
        this.omitNextAutocomplete = true;
        this.model = rawMatch.name;

        if (this.select) {
            this.select({match: rawMatch});
        }
    }

    selectOption(option) {
        this.model = option;
        this.showOptions = false;
        this.filteredOptions = {};
        this.search = search;
        this.searchUrl = '';

        if (this.submit) {
            this.submit({match: this.model});
        }
    }

    autocomplete(search) {
        if (this.omitNextAutocomplete) {
            this.omitNextAutocomplete = false;
            return;
        }

        this.showOptions = false;
        this.filteredOptions = {};
        this.search = search;
        this.searchUrl = '';
        this.selected = {key: '', index: -1};

        if (search === '') {
            return;
        }

        this.searchUrl = '/search/' + encodeURI(this.search);

        angular.forEach(this.options, (options, key) => {
            const matches = [];
            options = options.slice(0, key === 'products' ? 6 : (this.isMobile ? 2 : 4));

            angular.forEach(options, (o) => {
                name = o.name.toString();
                const index = name.toLowerCase().indexOf(search.toLowerCase());

                let text = '';

                if (index < 0 || key === 'products_categories') {
                    text = name;
                } else {
                    text = `${name.substring(0, index)}<strong>${name.substring(index, index + search.length)}</strong>${name.substring(index + search.length, name.length)}`;
                }

                let categoryTree = [];
                o.text = text;

                if (key !== 'products') {
                    categoryTree = this.getParentCategories(o).join('<img src="/templates/rowerystylowenew/assets/svg/arrow-right.svg" alt="arrow right">');
                }

                matches.push({
                    name: name,
                    link: o.link,
                    image: o.image,
                    price: o.price ? o.price : null,
                    rawMatch: o,
                    offset: index,
                    categoryTree: categoryTree,
                    left: name.length - index - search.length,
                    text: this.$sce.trustAsHtml(text)
                });
            });

            if (matches.length > 0) {
                this.showOptions = true;
                this.filteredOptions[key] = matches;
            }
        });
    }

    hasFilteredOptions() {
        if (!this.filteredOptions) {
            return false;
        }

        for (let filteredOption in this.filteredOptions) {
            if (filteredOption.length > 0) {
                return true;
            }
        }

        return false;
    }

    resetSelect() {
        this.showModal = true;
        this.selected = {key: '', index: -1};
    }

    getParentCategories(category, level = 0, categoryNames = []) {
        let name = category.text ? category.text : category.name;
        name = '<span class="category-tree-item' + (level === 0 ? ' last-child' : '') + '">' + name + '</span>';
        categoryNames.unshift(name);
        if (category.parent) {
            this.getParentCategories(category.parent, level + 1, categoryNames);
        }
        return categoryNames;
    }

    keyEvent(e) {
        if (e.keyCode === 27) {
            this.hideModal();
            return;
        }

        if (!this.filteredOptions) {
            return;
        }

        this.showModal = true;

        let selectKeys = this.selectKeys;

        switch (e.keyCode) {
            case 38:
                if (!this.selected.key) {
                    return;
                }
                if (this.selected.index > 0) {
                    this.selected.index--;
                } else if (selectKeys.indexOf(this.selected.key) - 1 >= 0) {
                    this.selected.key = selectKeys[selectKeys.indexOf(this.selected.key) - 1];
                    this.selected.index = this.filteredOptions[this.selected.key].length - 1;
                } else if (selectKeys.indexOf(this.selected.key) - 1 < 0) {
                    this.selected.key = selectKeys[selectKeys.length - 1];
                    this.selected.index = this.filteredOptions[this.selected.key].length - 1;
                }
                break;
            case 40:
                if (!this.selected.key) {
                    this.selected.key = selectKeys[0];
                }
                if (this.selected.index + 1 < this.filteredOptions[this.selected.key].length) {
                    this.selected.index++;
                } else if (this.selected.index + 1 >= this.filteredOptions[this.selected.key].length
                    && selectKeys.indexOf(this.selected.key) + 1 < selectKeys.length) {
                    this.selected.key = selectKeys[selectKeys.indexOf(this.selected.key) + 1];
                    this.selected.index = 0;
                } else if (this.selected.index + 1 >= this.filteredOptions[this.selected.key].length
                    && selectKeys.indexOf(this.selected.key) + 1 >= selectKeys.length) {
                    this.selected.key = selectKeys[0];
                    this.selected.index = 0;
                }
                break;
            case 13:
                if (!this.selected.key || this.selected.index < 0) {
                    if (this.submit && this.model != '') {
                        this.submit({match: this.model});
                    }
                }
                if (angular.isDefined(this.filteredOptions[this.selected.key][this.selected.index])) {
                    this.clickOption(this.filteredOptions[this.selected.key][this.selected.index].rawMatch);
                } else {
                    if (this.submit && this.model != '') {
                        this.submit({match: this.model});
                    }
                }
                break;
        }
    }
}

export default AutocompleteDirective;
